import { Component, Inject } from '@angular/core';
import { FormGroup, FormControl, ReactiveFormsModule } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Subscription } from 'rxjs';
import { environment } from '../../../environments/environment';
import { AddressService } from '../../services/address.service';
import { AnalyticsService } from '../../services/analytics.service';
import { UtilsService } from '../../services/utils.service';
import { CommonModule } from '@angular/common';
import { LimitNumberDirective } from '../../directives/limit-number.directive';

@Component({
  selector: 'app-choose-location-modal',
  standalone: true,
  imports: [CommonModule,ReactiveFormsModule,LimitNumberDirective],
  templateUrl: './choose-location-modal.component.html',
  styleUrl: './choose-location-modal.component.scss'
})
export class ChooseLocationModalComponent {
  environment: any = environment;
  pincodeForm: any;
  sub:Subscription=new Subscription()
  constructor(public utils: UtilsService, private analyticsService: AnalyticsService, public dialogRef: MatDialogRef<ChooseLocationModalComponent>, @Inject(MAT_DIALOG_DATA) public data: any, private addressSvc: AddressService) {
  }

  ngOnInit(): void {
    this.pincodeForm = new FormGroup({
      pinCode: new FormControl('')
    })
    this.pincodeForm.controls.pinCode.setValue(this.utils.getUserPicode() ? this.utils.getUserPicode() : '');
  }

  updatePinCode() {
    let pincode = this.pincodeForm.controls.pinCode.value ? String(this.pincodeForm.controls.pinCode.value) : '';
    if (pincode && pincode.length >= 6) {
      this.triggerPincodeAdded(pincode);
      this.utils.showLoading();
      this.sub.add(this.addressSvc.getCityDataFromPinCode(pincode).subscribe({
        next: (res: any) => {
          if (res.success && res.masterResponseList.length) {
            this.utils.setUserPicode(pincode);
            this.dialogRef.close(true)
          }
          else
            this.utils.openSnackBar('Please enter a valid pincode', 'error-toster');
          this.utils.hideLoading();
        }
      }))
    }
    else {
      this.utils.removeUserPincode();
      this.dialogRef.close(true);
    }
  }

  onNoClick(): void {
    this.dialogRef.close()
  }

  triggerPincodeAdded(pincode: string) {
    const data = {
      eventName: "PinCode Added",
      eventData: {
        'Pincode': parseInt(pincode)
      }
    };
    this.analyticsService.trackData(data);
  }
  ngOnDestroy(): void {

    this.sub.unsubscribe()
  }
}
